<div class="shadow-box flex flex-col items-center max-w-screen-sm w-full text-center dark:bg-background-dark">
    <img src="./assets/img/exam-start-penguin.webp" alt="Los gehts" class="w-40 h-40 my-4 rounded-full object-cover" />

    <h3>Wiederholungs-Modus!</h3>
    <p class="px-4 sm:px-20 text-center	mt-4">
        Hier hast du die Möglichkeit, Fragen erneut zu beantworten, die du in der Vergangenheit falsch beantwortet
        hast.<br>
        Sobald du eine Frage richtig beantwortet hast, verschwindet sie aus diesem Modus.<br>
        Du bekommst nach jeder Antwort eine kurze Rückmeldung, ob du richtig oder falsch gelegen hast.
    </p>
    <p class="px-4 sm:px-20 text-center">
        Viel Spaß!
    </p>
    <button [routerLink]="['/repeat']" class="blue-button mt-6 mb-10 w-3/4">Starten</button>

    <!-- <div class="text-xs text-grey">This product is not affiliated with nor endorsed by scrum.org. All questions are self-created and based solely on the publicly available Scrum Guide.</div> -->
    <div class="text-xs dark:text-grey text-gray-400">Dieses Produkt steht in keiner Verbindung zu scrum.org und wird von dieser weder
        unterstützt noch gefördert. Alle Fragen sind selbst erstellt und basieren ausschließlich auf dem öffentlich
        verfügbaren Scrum Guide.</div>
</div>